module.exports = __webpack_public_path__ + "img/header-styria-hq.5040cd06.jpg";